import { useTranslation } from "react-i18next";
import CheckBox from '@mui/material/Checkbox';
import { useEffect } from "react";
import TextInput from '../../Fields/TextInput';

const SearchFee = (props) => {

    const {formJson, setFormJson, toggle = false} = props
    const { t, i18n } = useTranslation('common');
    const sequenceCount = Number(formJson?.layout?.queryCount || 0);
    const billableSequenceCount = Math.max(1, sequenceCount);
    const groupVoucherCredits = Number(formJson?.layout?.group_voucher_credits || 0);
    const voucherCreditsToUse = Number(formJson?.layout?.voucherCreditsToUse || 0);
    const totalCharge = 935 * billableSequenceCount - voucherCreditsToUse * 935;
    const availableCredits = Number(formJson?.layout?.group_credits || 0);
    const creditPerSequence = 1;
    const totalCreditsNeeded = billableSequenceCount;
    const remainingCredits = availableCredits - totalCreditsNeeded + Math.min(voucherCreditsToUse, totalCreditsNeeded);

    useEffect(() => {
        const maxVoucher = Math.min(groupVoucherCredits, billableSequenceCount);
        if (voucherCreditsToUse > maxVoucher) {
            formJson.layout.voucherCreditsToUse = maxVoucher;
            setFormJson({ ...formJson });
        }
    }, [billableSequenceCount]);

    useEffect(() => {
        if(formJson.layout.BundleUserAccepted == null){
            formJson.layout.BundleUserAccepted = false;
            formJson.layout.errorIdList.push("checkTerms");
        }
    },[])

    return (
        <>
        {formJson.searchInfo.ppuType != null && formJson.searchInfo.ppuType > 0 &&
        <div>
            <p className="subHeading" >Search Fee</p>
            {groupVoucherCredits > 0 && (
                <div className="d-flex align-items-center mb-2" style={{ gap: '8px' }}>
                    <span className="bodyText">Use</span>
                    <TextInput
                        type="number"
                        variant="outlined"
                        inputProps={{ min: 0, max: Math.min(groupVoucherCredits, billableSequenceCount) }}
                        value={voucherCreditsToUse}
                        onChange={(e) => {
                            formJson.layout.voucherCreditsToUse = Math.min(Math.max(0, Number(e.target.value)), Math.min(groupVoucherCredits, billableSequenceCount));
                            setFormJson({...formJson});
                        }}
                        style={{ width: '80px' }}
                        InputProps={{ style: { borderRadius: '7px', border: '2px solid #337AB7' } }}
                    />
                    <span className="bodyText">of my <strong>{groupVoucherCredits}</strong> available voucher credits</span>
                </div>
            )}
            <div>
                
                {formJson.searchInfo.ppuType === 1 &&
                <>
                    <p>{t('executingSearchCharges')}</p>
                    <div>
                        <p className="ml-3" style={{marginBottom: "7px", paddingBottom: "7px"}}>{billableSequenceCount} query sequence(s) @ $935.00 per query sequence</p>
                        {voucherCreditsToUse > 0 && (
                            <p className="ml-3" style={{marginBottom: "7px"}}>-${voucherCreditsToUse * 935} {t("voucherDiscount")} ({voucherCreditsToUse} {t("credits")})</p>
                        )}
                        <p className="ml-3 subHeading" style={{marginBottom: "7px"}}>${totalCharge} {t('total')}</p>
                    </div>
                </>
                }
                {formJson.searchInfo.ppuType === 2 && 
                <>
                    {formJson.layout.isRedo &&
                    <div>
                        <p style={{paddingLeft: "12px", marginBottom: "7px"}}> There is <strong>NO FEE</strong> for Chemical Modifications search redos</p>
                    </div>
                    }
                    {!formJson.layout.isRedo &&
                    <div>
                        <p>{t('executingSearchCredits')}</p>
                        <div>
                            <p className="ml-3" style={{marginBottom: "7px"}}>1 Credit used per query sequence</p>
                            <p className="ml-3 subHeading" style={{marginBottom: "7px", padding: "10px 0"}}>{billableSequenceCount} TOTAL credit used by sequences</p>
                            {voucherCreditsToUse > 0 && (
                                <p className="ml-3" style={{marginBottom: "7px"}}>-{voucherCreditsToUse} {t("voucherCreditsApplied")}</p>
                            )}
                        </div>
                        <div className="subHeading">
                            <p className={remainingCredits < 0 ? "ml-3 subHeadingRed" : "ml-3 subHeading"} style={{marginBottom: "7px"}}>{remainingCredits} {t('creditsRemaining')}</p>
                        </div>
                    </div>
                    }
                </>
                }
            </div>
            
            <CheckBox
                // defaultChecked
                color="primary"
                id="checkTerms"
                disabled ={remainingCredits < 0 && formJson.searchInfo.ppuType ===2 && !formJson.layout.isRedo}
                onChange={(e) => {
                    let accept = e.target.checked;
                    formJson.layout.BundleUserAccepted = accept;
                    setFormJson({...formJson});
                    
                    if(accept){
                        let index = formJson.layout.errorIdList.indexOf("checkTerms");
                        if(index > -1){
                            formJson.layout.errorIdList.splice(index, 1);
                        }
                    }else{
                        if(!formJson.layout.errorIdList.includes("checkTerms")){
                            formJson.layout.errorIdList.push("checkTerms");
                        }
                    }
                
                }}
                //onChange={handleppuCredits}
                checked={formJson.layout.BundleUserAccepted}
                style={{ color: (toggle ? '': '#aea9a9' ), marginLeft: "-6px"}}
                error={formJson.layout.errorIdList.includes("checkTerms")}
            />
            <label htmlFor="checkTerms" style={{marginLeft: "-5px"}} className={"bodyText cursorPointer"}>{t("acceptTermsCheckBox")}</label>

        </div>
        }
        </>
    );
};

export default SearchFee;